// German translations
const translations = {
  // Navigation
  dashboard: "Dashboard",
  excavators: "Baumaschinen",
  reports: "Berichte",
  users: "Benutzer",
  profile: "Profil",
  logout: "Abmelden",
  login: "Anmelden",
  register: "Registrieren",
  management: "Verwaltung",
  analytics: "Analysen",
  hello: "Hallo",
  hoursRemaining: "Stunden verbleibend",
  todaysDate: "Heutiges Datum",
  maintenanceReportSystem: "FleetPilot",
  reportQuickView: "Bericht Schnellansicht",
  changeLanguage: "Sprache ändern",
  dashboardSubtitle:
    "Verwalten Sie Ihre Baumaschinen und Wartungsberichte effizient",
  setLastMaintenanceDate: "Letztes Wartungsdatum festlegen",
  backToList: "Zurück zur Liste",
  checklistDetails: "Checklisten-Details",
  noChecklistDataAvailable: "Keine Checklisten-Daten verfügbar",
  checklistDataWillAppearHere: "Checklisten-Daten werden hier angezeigt",
  item: "Element",
  pending: "Ausstehend",
  Saturday: "Samstag",
  Sunday: "Sonntag",
  Monday: "Montag",
  Tuesday: "Dienstag",
  Wednesday: "Mittwoch",
  Thursday: "Donnerstag",
  Friday: "Freitag",
  notesAndObservations: "Notizen und Beobachtungen",
  Dashboard: "Dashboard",
  welcomeBack: "Willkommen zurück",
  selectLanguage: "Sprache auswählen",
  createNewReport: "Neuen Bericht erstellen",
  viewAllReports: "Alle Berichte anzeigen",
  fromLastMonth: "Vom letzten Monat",
  requiresAttention: "Benötigt Aufmerksamkeit",
  lastSixMonths: "Letzte sechs Monate",
  noRecentReports: "Keine aktuellen Berichte",
  noPendingReports: "Keine ausstehenden Berichte",
  inspection: "Inspektion",
  recentReports: "Aktuelle Berichte",
  viewDetails: "Details anzeigen",
  personnel: "Personal",
  entryDetails: "Eintragsdetails",
  viewReports: "Bericht ansehen",
  viewAllUsers: "Alle Benutzer anzeigen",
  items: "Prüfungsstellen",
  refreshing: "Aktualisieren...",
  reportStatus: "Berichtsstatus",
  allSigned: "Alle Berichte sind unterschrieben",
  excellent: "Ausgezeichnet",
  active: "Aktiv",
  signedby: "Unterschrieben von",
  excavatorHealth: "Gesundheit der Baumaschinen",
  needsAttention: "Benötigt Aufmerksamkeit",
  healthScore: "Gesundheitsbewertung",
  noExcavatorData: "Keine Baumaschinen-Daten verfügbar",
  noOperatorData: "Keine Bediener-Daten verfügbar",
  byReportCount: "Nach Berichtsanzahl",
  topOperators: "Top Bediener",
  topExcavators: "Top Baumaschinen",
  refresh: "Aktualisieren",
  searchExcavators: "Baumaschinen suchen",
  maintenanceReport: "Wartungsbericht",
  created: "Erstellt am",
  approved: "Genehmigt",
  createdAt: "Erstellt am",
  signReport: "Bericht unterschreiben",
  signReportDescription:
    "Bitte unterschreiben Sie den Bericht, um ihn zu genehmigen. Ihre Unterschrift wird zur Genehmigung des Berichts verwendet.",
  signatureArea: "Unterschriftsbereich",
  signAndApprove: "Unterschreiben und genehmigen",
  signingAs: "Sie unterschreiben als",
  useProfileSignature:
    "Unterschrift des Benutzers",
  "Invalid Date": "Ungültiges Datum",
  recentBetriebstagebuch: "Aktuelle Betriebstagebuch-Einträge",
  details: "Details",
  equipmentAndPersonnel: "Ausrüstung und Personal",
  Berichtsdetails: "Berichtsdetails",
  lastLogin: "Letzte Anmeldung",
  searchByNameEmailRole: "Nach Name, E-Mail oder Rolle suchen",
  adminFullAccess: "Administrator - Vollzugriff",
  managerAccess: "Manager - Eingeschränkter Zugriff",
  operatorAccess: "Bediener - Eingeschränkter Zugriff",
  newPasswordLeaveBlank:
    "Neues Passwort (leer lassen, um das aktuelle Passwort zu behalten)",
  enterFullName: "Vollständigen Namen eingeben",
  noReportsFound: "Keine Berichte gefunden",
  noReportsCreatedYet: "Noch keine Berichte erstellt",
  next: "Nächste",
  // Excavator table headers
  manufacturer: "Hersteller",
  model: "Modell",
  serialNumber: "Seriennummer",
  year: "Baujahr",
  status: "Status",
  lastMaintenance: "Letzte Wartung",
  actions: "Aktionen",
  excavatorList: "Baumaschinen Liste",
  daysOverdue: "Tage überfällig",
  thisMonth: "Dieser Monat",
  planMaintenance: "Geplante Wartung",
  normalMaintenance: "Normale Wartung",
  daysSinceLastMaintenance: "Tage seit letzter Wartung",
  recommendedAction: "Empfohlene Aktion",
  mostCommonType: "Häufigster Typ",
  totalItems: "Gesamtanzahl der Elemente",
  categories: "Kategorien",
  undefined: "Nicht definiert",
  entriesThisMonth: "Einträge in diesem Monat",
  unsignedEntries: "Nicht unterschriebene Einträge",
  totalEntries: "Gesamtanzahl der Einträge",
  lastEntryDate: "Letztes Eintragsdatum",
  appName: "FleetPilot ",
  // Report table headers
  reportId: "Berichts-ID",
  excavator: "Baumaschinen",
  type: "Typ",
  date: "Datum",
  technician: "Bediener", // Technician translated as "Bediener" (Operator)
  report: "Bericht",
  machine: "Maschine",
  approvalConfirmation:
    "Sind Sie sicher, dass Sie diesen Bericht genehmigen möchten?",
  clearSignature: "Unterschrift löschen",
  approve: "Genehmigen",
  // Actions
  view: "Ansehen",
  edit: "Bearbeiten",
  delete: "Löschen",
  add: "Hinzufügen",
  addExcavator: "Baumaschinen hinzufügen",
  addReport: "Bericht erstellen",
  setOperational: "Als betriebsbereit markieren",
  assignOperator: "Bediener zuweisen",
  scheduleMaintenance: "Wartung planen",
  betriebstagebuchQuickView: "Betriebstagebuch Schnellansicht",
  // Status options
  operational: "Betriebsbereit",
  maintenance: "In Wartung",
  repair: "In Reparatur",
  outOfService: "Außer Betrieb",
  signed: "Unterschrieben",
  unsigned: "Nicht unterschrieben",
  pendingApproval: "Ausstehende Genehmigung",
  completed: "Abgeschlossen",
  entryId: "Eintrags-ID",

  // Form labels
  save: "Speichern",
  cancel: "Abbrechen",
  uploadImage: "Bild hochladen",

  // Other common text
  confirmDelete: "Möchten Sie diesen Eintrag wirklich löschen?",
  noDataAvailable: "Keine Daten verfügbar",
  loading: "Wird geladen...",
  error: "Fehler",
  success: "Erfolg",

  // 404 Page
  pageNotFound: "Seite nicht gefunden",
  pageNotFoundMessage:
    "Die gesuchte Seite wurde möglicherweise entfernt, umbenannt oder ist vorübergehend nicht verfügbar.",
  goToDashboard: "Zum Dashboard",
  goBack: "Zurück",

  // Footer
  version: "Version",

  // User Management
  userManagement: "Benutzerverwaltung",
  createUser: "Benutzer erstellen",
  editUser: "Benutzer bearbeiten",
  deleteUser: "Benutzer löschen",
  name: "Name",
  email: "E-Mail",
  role: "Rolle",
  password: "Passwort",
  confirmPassword: "Passwort bestätigen",
  administrator: "Administrator",
  manager: "Manager",
  operator: "Bediener",

  // Profile page
  changePassword: "Passwort ändern",
  currentPassword: "Aktuelles Passwort",
  newPassword: "Neues Passwort",
  updatePassword: "Passwort aktualisieren",
  userProfile: "Benutzerprofil",
  personalDetails: "Persönliche Daten",
  department: "Abteilung",
  phoneNumber: "Telefonnummer",
  yourSignature: "Unterschrift",
  saveChanges: "Änderungen speichern",
  uploadProfileImage: "Profilbild hochladen",
  security: "Sicherheit",
  signature: "Unterschrift hinzufügen",
  signatureDescription:
    "Bitte fügen Sie Ihre Unterschrift hinzu, um Berichte zu genehmigen.",
  signatureTips:
    "Unterschrift hinzufügen: Verwenden Sie den Stift, um Ihre Unterschrift zu zeichnen. Klicken Sie auf 'Unterschrift speichern', um Ihre Unterschrift zu speichern.",
  signatureTip1:
    "Unterschrift hinzufügen: Verwenden Sie den Stift, um Ihre Unterschrift zu zeichnen.",
  signatureTip2:
    "Klicken Sie auf 'Unterschrift speichern', um Ihre Unterschrift zu speichern.",
  signatureTip3:
    "Klicken Sie auf 'Unterschrift löschen', um Ihre Unterschrift zu entfernen.",
  signatureTip4:
    "Klicken Sie auf 'Unterschrift speichern', um Ihre Unterschrift zu speichern.",
  currentSignature: "Aktuelle Unterschrift",
  emailCannotBeChanged: "Die E-Mail-Adresse kann nicht geändert werden",
  fullName: "Vollständiger Name",
  memberSince: "Mitglied seit",
  systemDescription: "Das Wartungsberichtsystem ist eine webbasierte Anwendung, die es Benutzern ermöglicht, Wartungsberichte für Baumaschinen zu erstellen, zu genehmigen und zu verwalten.",
  registerToJoinDescription:
    "Registrieren Sie sich, um dem Wartungsberichtsystem beizutreten und alle Funktionen zu nutzen.",
  registerToJoin:
    "Registrieren Sie sich, um dem Wartungsberichtsystem beizutreten",
  forgotPassword: "Passwort vergessen?",
  // Login/Register
  loginToAccess: "Anmelden für Systemzugriff",
  createAccount: "Konto erstellen",
  alreadyHaveAccount: "Haben Sie bereits ein Konto?",
  dontHaveAccount: "Haben Sie kein Konto?",
  enterEmail: "E-Mail-Adresse eingeben",
  enterPassword: "Passwort eingeben",
  enterName: "Namen eingeben",
  confirmYourPassword: "Passwort bestätigen",
  or: "ODER",
  emailRequired: "E-Mail ist erforderlich",
  pleaseEnterValidEmail: "Bitte geben Sie eine gültige E-Mail ein",
  passwordRequired: "Passwort ist erforderlich",
  passwordMinLength: "Passwort muss mindestens 6 Zeichen lang sein",
  loggingIn: "Anmeldung läuft...",
  notesAndSignatures: "Notizen und Unterschrift",
  createEntry: "Eintrag erstellen",
  batchGenerate: "Stapelweise Einträge erstellen",
  openMenu: "Menü öffnen",
  collapseMenu: "Menü einklappen",
  darkModeEnabled: "Dunkelmodus aktiviert",
  lightModeEnabled: "Hellmodus aktiviert",
  searchEntries: "Einträge suchen",
  shiftStart: "Schichtbeginn",
  shiftEnd: "Schichtende",
  weather: "Wetter",
  temperature: "Temperatur",
  noNotesRecorded: "Keine Notizen aufgezeichnet",
  tableView: "Tabellenansicht",
  cardView: "Kartenansicht",
  searchReports: "Berichte suchen",
  searchPlaceholder: "Datum (dd.mm.yyyy, dd.mm, yyyy), Bediener, Maschine...",
  searchHelp: "Suche nach Datum, Bediener, Maschinenmodell/-hersteller oder beliebigem Text",
  searchBetriebstageBuchPlaceholder: "Datum (dd.mm.yyyy, dd.mm, yyyy), Aussteller-Name...",
  searchBetriebstageBuchHelp: "Suche nach Datum, Aussteller-Name oder beliebigem Text",
  operatingHoursAtReport: "Betriebsstunden im Bericht",
  reportDate: "Berichtsdatum",
  betriebstagebuchEntry: "Betriebstagebuch-Eintrag",
  editEntry: "Eintrag bearbeiten",
  approveEntry: "Eintrag genehmigen",
  noIncidents: "Keine Vorfälle",
  foreignMaterialControl: "Eigen-,Fremd, und Anlieferkontrolle",
  keyInformation: "Schlüsselinformationen",
  summary: "Zusammenfassung",
  drawSignature: "Unterschrift zeichnen",
  general: "Allgemein",
  finish: "Fertigstellen",
  clearAndRedraw: "Löschen und neu zeichnen",

  // Dashboard
  welcome: "Willkommen zurück",
  viewProfile: "Profil anzeigen",
  quickActions: "Schnellaktionen",
  recentActivity: "Letzte Aktivitäten",
  maintenanceStatus: "Wartungsstatus",
  monthlyReports: "Monatliche Berichte",
  statistics: "Statistiken",
  createReport: "Bericht erstellen",
  pendingWork: "Ausstehende Arbeiten",
  viewReportStatistics: "Berichtsstatistiken anzeigen",
  totalExcavators: "Gesamtanzahl Baumaschinen",
  activeExcavators: "Aktive Baumaschinen",
  totalReports: "Gesamtanzahl Berichte",
  pendingReports: "Ausstehende Berichte",
  loadingDashboard: "Dashboard-Daten werden geladen...",
  failedToLoadDashboard:
    "Fehler beim Laden der Dashboard-Daten. Bitte versuchen Sie es erneut.",
  viewAll: "Alle anzeigen",
  address: "Herzbergstraße 19-21, 10365 Berlin, Deutschland",
  allRightsReserved: "Alle Rechte vorbehalten",
  contactUs: "Kontaktieren Sie uns",
  documentation: "Dokumentation",
  support: "Unterstützung",
  help: "Hilfe",
  termsOfService: "Nutzungsbedingungen",
  privacyPolicy: "Datenschutz-Bestimmungen",
  footerDescription: "Überall zu jeder Zeit",
  // Filter and Search
  filter: "Filter",
  search: "Suchen",
  excavatorSearchPlaceholder: "Nach Modell, Hersteller, Seriennummer suchen...",
  clear: "Löschen",
  all: "Alle",
  upToDate: "Aktuell",
  maintenanceDue: "Wartung fällig",
  overdue: "Überfällig",
  resetFilters: "Filter zurücksetzen",
  applyFilters: "Filter anwenden",
  never: "Nie",
  specialChecks: "Sonderprüfungen",
  addSpecialCheck: "Sonderprüfungen hinzufügen",
  // Report Detail Page
  "reports.totalReports": "Gesamtanzahl Berichte",
  "reports.statistics": "Berichtsstatistiken",
  "reports.thisMonth": "Monatliche Berichte",
  "reports.pending": "Ausstehende Berichte",
  "reports.completed": "Abgeschlossene Berichte",
  noGeneralNotesProvided: "Keine allgemeinen Anmerkungen vorhanden",
  close: "Schließen",
  serviceDate: "Berichtsdatum",
  size: "Größe",
  machineType: "Maschinentyp",
  Wheeled: "Raupen",
  viewFullDetails: "Vollständige Details anzeigen",
  downloadPdf: "PDF herunterladen",
  loadingReport: "Bericht wird geladen...",
  failedToLoadReport: "Fehler beim Laden des Berichts",
  errorDownloadingPDF: "Fehler beim Herunterladen der PDF-Datei",
  signatureRequired: "Unterschrift erforderlich",
  nameRequired: "Name erforderlich",
  reviewerName: "Name des Prüfers",
  clearPad: "Unterschrift löschen",
  saveSignature: "Unterschrift speichern",
  enterYourName: "Geben Sie Ihren Namen ein",
  onlyManagersCanApprove: "Nur Manager können Berichte genehmigen",
  downloading: "Wird heruntergeladen...",
  downloadPDF: "PDF herunterladen",
  approveReport: "Bericht genehmigen",
  editReport: "Bericht bearbeiten",
  maintenanceReportDetails: "Wartungsbericht Details",
  back: "Zurück",
  reportNotFound: "Bericht nicht gefunden",
  reportNotFoundMessage:
    "Der angeforderte Bericht konnte nicht gefunden werden",
  approveMaintenanceReport: "Wartungsbericht genehmigen",
  managerName: "Name des Managers",
  createdOn: "Erstellt am",
  excavatorInformation: "Baumaschinen-Informationen",
  unknown: "Unbekannt",
  "n/a": "Nicht angegeben",
  serviceInformation: "Service-Informationen",
  serviceType: "Service-Typ",
  equipmentHours: "Betriebsstunden",
  location: "Standort",
  routine: "Routine",
  exterior: "Außenbereich",
  interior: "Innenbereich",
  engine: "Motor",
  cleaning: "Reinigung",
  notes: "Anmerkungen",
  checklist: "Checkliste",
  additionalNotes: "Zusätzliche Anmerkungen",
  noAdditionalNotesProvided: "Keine zusätzlichen Anmerkungen vorhanden",
  signatures: "Unterschriften",
  technicianSignature: "Unterschrift des Bedieners",
  noSignatureAvailable: "Keine Unterschrift verfügbar",
  signedBy: "Unterschrieben von",
  managerApproval: "Genehmigung des Managers",
  approvedBy: "Genehmigt von",
  thisReportIsWaitingForYourApproval:
    "Dieser Bericht wartet auf Ihre Genehmigung",
  pendingManagerApproval: "Ausstehende Genehmigung des Managers",
  signAndApproveNow: "Jetzt unterschreiben und genehmigen",
  processing: "Wird verarbeitet...",
  sign: "Unterschreiben",
  noInspectionDataAvailableFor: "Keine Inspektionsdaten verfügbar für",
  notSpecified: "Nicht angegeben",
  tryAgain: "Erneut versuchen",
  generalInformation: "Allgemeine Informationen",
  technicalDetails: "Technische Details",
  maintenanceChecklist: "Wartungscheckliste",
  operatingHours: "Betriebsstunden",
  hours: "Stunden",
  maintenanceType: "Wartungstyp",
  reviewedBy: "Geprüft von",
  signedDate: "Datum der Unterzeichnung",
  hydraulic: "Hydraulik",
  routineMaintenance: "Routinewartung",
  failedToApproveReport: "Fehler beim Genehmigen des Berichts",
  reportApprovedSuccessfully: "Bericht erfolgreich genehmigt",
  specialChecksSummary: "Zusammenfassung der Sonderprüfungen",
  // Create Report Page
  createMaintenanceReport: "Wartungsbericht erstellen",
  selectExcavator: "Baumaschinen auswählen",
  pleaseSelectExcavator: "Bitte wählen Sie einen Baumaschinen aus",
  reportDetails: "Berichtsdetails",
  maintenanceDate: "Wartungsdatum",
  nextMaintenanceDate: "Nächstes Wartungsdatum",
  technicianName: "Name des Bedieners",
  inspectionChecklist: "Inspektions-Checkliste",
  // Check category names
  exteriorChecks: "Außenbereich-Prüfungen",
  interiorChecks: "Innenbereich-Prüfungen",
  engineChecks: "Motor-Prüfungen",
  hydraulicChecks: "Hydraulik-Prüfungen",
  cleaningChecks: "Reinigung-Prüfungen",
  issues: "Probleme",
  complete: "Abgeschlossen",
  approveAndSign: "Genehmigen und Unterschreiben",
  checked: "Überprüft",
  managerSignature: "Unterschrift des Betriebsleiters",

  notApplicable: "Nicht zutreffend",
  notDone: "Nicht durchgeführt",
  additionalComments: "Zusätzliche Kommentare",
  submitReport: "Bericht einreichen",
  pleaseAddSignature: "Bitte fügen Sie Ihre Unterschrift hinzu",
  pleaseSelectDate: "Bitte wählen Sie ein Datum",
  reportSubmittedSuccessfully: "Bericht erfolgreich eingereicht",
  failedToSubmitReport: "Fehler beim Einreichen des Berichts",
  submitting: "Wird eingereicht...",

  // Chart labels
  chartReportsByMonth: "Nach Monat eingereichte Berichte",
  chartNumberOfReports: "Anzahl der Berichte",
  itemsCompleted: "Abgeschlossene Elemente",
  completionStatus: "Abschlussstatus",
  checksCompleted: "Abgeschlossene Prüfungen",
  notesAdded: "Hinzugefügte Anmerkungen",
  // Report checklist items
  chassis: "Fahrwerk",
  tracks: "Raupen",
  boom: "Ausleger",
  bucket: "Schaufel",
  arm: "Arm",
  hydraulics: "Hydraulik",
  hydraulicLines: "Hydraulikleitungen",
  hydraulicLeaks: "Hydrauliklecks",
  oilLeaks: "Ölleckagen",
  bodyDamage: "Körperschäden",
  mirrors: "Spiegel",
  windows: "Fenster",
  cameras: "Kameras",
  lights: "Lichter",
  wipers: "Scheibenwischer",
  lubricationSystem: "Schmiersystem",
  seat: "Sitz",
  seatbelt: "Sicherheitsgurt",
  electronics: "Elektronik",
  heating: "Heizung",
  airConditioning: "Klimaanlage",
  radioFunction: "Radiofunktion",
  emergencyStops: "Notstopps",
  joystick: "Joystick",
  display: "Display",
  dashboardInstruments: "Armaturenbrett",
  controls: "Steuerungen",
  parkingBrake: "Feststellbremse",
  engineOil: "Motoröl",
  oilLevel: "Ölstand",
  hydraulicOil: "Hydrauliköl",
  coolant: "Kühlmittel",
  coolantLevel: "Kühlmittelstand",
  fuelLevelCheck: "Kraftstoffstand",
  batteryCondition: "Batteriezustand",
  engineNoise: "Motorgeräusch",
  exhaustSmoke: "Abgasrauch",
  windshieldWasher: "Scheibenwaschanlage",
  transmissionOil: "Getriebeöl",
  fuelFilter: "Kraftstofffilter",
  airFilter: "Luftfilter",
  belts: "Riemen",
  // Cleaning items
  washed: "Gewaschen",
  exteriorCleaning: "Außenreinigung",
  interiorCleaning: "Innenreinigung",
  windowsCleaned: "Fenster gereinigt",
  windowsCleaning: "Fensterreinigung",
  tracksCleaning: "Raupenreinigung",
  mirrorsCleaned: "Spiegel gereinigt",
  interiorWindowsCleaned: "Innenscheiben gereinigt",
  interiorWiped: "Innenraum abgewischt",
  interiorVacuumed: "Innenraum gesaugt",
  fuelLevel: "Kraftstoffstand",
  startDate: "Startdatum",
  endDate: "Enddatum",
  nextInspectionDate: "Nächstes Inspektionsdatum",
  noMatchingReports: "Keine übereinstimmenden Berichte gefunden",
  tryDifferentSearch: "Versuchen Sie, Ihre Suche zu ändern",
  allStatuses: "Alle Status",
  allIssuers: "Alle Aussteller",
  tryAdjustingFilters: "Versuchen Sie, die Filter anzupassen",
  noMatchingEntries: "Keine übereinstimmenden Einträge gefunden",
  allFields: "Alle Felder",
  approvedEntries: "Genehmigte Einträge",

  defaultSpecialChecks: "Standard-Sonderprüfungen",
  defaultGeneralNotes: "Standard-Allgemeine Anmerkungen",
  notesForAllEntries: "Anmerkungen für alle Einträge",

  itemCategories: "Elementkategorien",
  totalInventoryItems: "Gesamtanzahl der Inventarelemente",
  lastInventoryUpdate: "Letztes Inventar-Update",
  issuer: "Aussteller",
  // Betriebstagebuch
  betriebstagebuch: "Betriebstagebuch",
  betriebstagebuchList: "Betriebstagebuch Liste",
  createBetriebstagebuch: "Betriebstagebuch erstellen",
  editBetriebstagebuch: "Betriebstagebuch bearbeiten",
  viewBetriebstagebuch: "Betriebstagebuch ansehen",
  betriebstagebuchDetails: "Betriebstagebuch Details",
  conveyorChecks: "Förderband-Prüfungen",
  conveyorName: "Förderband-Name",
  functional: "Funktionsfähig",
  notFunctional: "Nicht funktionsfähig",
  conveyorNotes: "Anmerkungen zu diesem Förderband",
  generalNotes: "Allgemeine Anmerkungen",
  addConveyor: "Förderband hinzufügen",
  removeConveyor: "Entfernen",
  noConveyorsAdded: "Es wurden noch keine Förderbänder hinzugefügt",
  entryDate: "Eintrags-Datum",
  createdBy: "Erstellt von",
  creator: "Ersteller",
  reviewer: "Prüfer",
  quickView: "Ansehen",
  tryChangingFilters: "Versuchen Sie, die Filter zu ändern",
  reviewerSignature: "Unterschrift des Prüfers",
  creatorSignature: "Unterschrift des Erstellers",
  betriebstagebuchCreated: "Betriebstagebuch-Eintrag erfolgreich erstellt",
  betriebstagebuchUpdated: "Betriebstagebuch-Eintrag erfolgreich aktualisiert",
  betriebstagebuchApproved: "Betriebstagebuch-Eintrag erfolgreich genehmigt",
  betriebstagebuchDeleted: "Betriebstagebuch-Eintrag erfolgreich gelöscht",
  downloadBetriebstagebuchPDF: "PDF herunterladen",
  approveBetriebstagebuch: "Eintrag genehmigen",
  recyclingCenter: "Recyclingzentrum",
  sortingMachine: "Sortieranlage",
  allConveyorsMustBeNamed: "Alle Förderbänder müssen benannt werden",
  errorSavingEntry: "Fehler beim Speichern des Eintrags",
  conveyorChecksSummary: "Zusammenfassung der Förderband-Prüfungen",
  noSpecialChecksRecorded: "Keine speziellen Prüfungen aufgezeichnet",
  reviewedOn: "Überprüft am",
  apply: "Anwenden",
  reset: "Zurücksetzen",
  rowsPerPage: "Zeilen pro Seite",
  of: "von",
  searchExcavatorsPlaceholder:
    "Nach Modell, Hersteller, Seriennummer oder Typ suchen...",
  searchBy: "Suche nach",
  noMatchingResults: "Keine Übereinstimmungen gefunden",
  clearSearch: "Suche zurücksetzen",
  // Batch Betriebstagebuch creation
  batchGenerateBetriebstagebuch: "Betriebstagebücher für Zeitraum erstellen",
  createMultipleEntries: "Mehrere Einträge auf einmal erstellen",
  dateRange: "Zeitraum",
  addNewUser: "Neuen Benutzer hinzufügen",
  nextMaintenance: "Nächste Wartung",
  daysInRange: "Tage im Zeitraum",
  entriesToBeGenerated: "Zu erstellende Einträge",
  allEntriesWillHaveYourSignature:
    "Alle Einträge werden mit Ihrer Unterschrift versehen",
  generateEntries: "Einträge erstellen",
  generating: "Wird erstellt...",
  generatedEntries: "Erstellte Einträge",
  betriebstagebuchEntriesGenerated:
    "Betriebstagebuch-Einträge erfolgreich erstellt",
  errorGeneratingEntries: "Fehler beim Erstellen der Betriebstagebuch-Einträge",
  dayOfWeek: "Wochentag",
  pleaseSelectDateRange: "Bitte wählen Sie einen Zeitraum",
  endDateMustBeAfterStartDate: "Enddatum muss nach Startdatum liegen",
  onlyAdminsCanBatchGenerate:
    "Nur Administratoren können Betriebstagebücher im Stapel erstellen",
  allConveyorsWillBeAddedToEachEntry:
    "Alle Förderbänder werden zu jedem Eintrag hinzugefügt",
  weekendsAreExcluded:
    "Wochenenden (Samstag und Sonntag) werden automatisch ausgeschlossen",
  preview: "Vorschau",
  allSpecialChecksMustBeNamed:
    "Alle speziellen Prüfungen müssen benannt werden",
  specialCheckNotes: "Anmerkungen zu dieser Prüfung",
  checkName: "Prüfungsname",
  notCompleted: "Nicht durchgeführt",

  // Conveyor Names
  AT: "AT",
  Steigband: "Steigband",
  Trommel: "Trommel",
  HeckBand: "HeckBand",
  SortierBand: "SortierBand",
  MagnetSortierHaus: "MagnetSortierHaus",
  MagnetHalle: "MagnetHalle",
  SeitenBand: "SeitenBand",
  Zuführband: "Zuführband",
  TrommelWindsichter: "TrommelWindsichter",
  SpeedBand: "SpeedBand",
  Airlift: "Airlift",
  Airwheel: "Airwheel",
  Ventilator: "Ventilator",
  overview: "Überblick",
  description: "Beschreibung",
  daysUntilDue: "Tage bis fällig",
  days: "Tage",
  upcomingMaintenances: "Bevorstehende Wartungen",
  selectExcavatorAndLocation: "Baumaschine und Standort auswählen",
  checks: "Prüfungen",
  noChecklistData: "Keine Checklisten-Daten",
  hasIncompleteChecks: "Unvollständige Prüfungen vorhanden",
  allChecksCompleted: "Alle Prüfungen abgeschlossen",
  approveEntryConfirmation:
    "Sind Sie sicher, dass Sie diesen Eintrag genehmigen möchten? ",
  useMyProfileSignature: "Meine Profilunterschrift verwenden",
  drawNewSignature: "Neue Unterschrift zeichnen",
  checklistSummary: "Checklisten-Zusammenfassung",
  overallProgress: "Gesamtfortschritt",
  itemsChecked: "Prüfungsstellen überprüft",
  remaining: "Verbleibend",
  // New translations
  updateHours: "Stunden aktualisieren",
  updateOperatingHours: "Betriebsstunden aktualisieren",
  featureComingSoon: "Funktion kommt bald",
  uvvStatus: "UVV-Status",
  nextInspection: "Nächste Prüfung",
  noDescription: "Keine Beschreibung vorhanden",
  noNotes: "Keine Notizen vorhanden",
  noData: "Keine Daten vorhanden",
  gallery: "Galerie",
  attachments: "Anhänge",
  comments: "Kommentare",
  relatedEquipment: "Verwandte Maschinen",
  select: "Auswählen",
  assign: "Zuweisen",
  schedule: "Planen",
  reportsAvailable: "Berichte verfügbar",
  bulkSignErrorTitle: "Fehler beim Massenunterschreiben",
  currentUserDataMissingError: "Benutzerdaten für das Massenunterschreiben fehlen.",
  reportsList: "Berichte Liste",

  "inventory.maker": "Hersteller",
  "inventory.model": "Modell",
  "inventory.type": "Typ",
  "inventory.quantity": "Menge",
  "inventory.image": "Bild",
  "inventory.notes": "Notizen",
  "inventory.lastUpdated": "Zuletzt aktualisiert",
  "inventory.addItem": "Artikel hinzufügen",
  "inventory.listTitle": "Inventar Liste",
  "common.actions": "Aktionen",
  "common.edit": "Bearbeiten",
  "common.delete": "Löschen",
  "inventory.deleteConfirmText": "Möchten Sie diesen Artikel wirklich löschen?",
  "inventory.deleteConfirmTitle":
    "Artikel löschen bestätigen",
  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.saveChanges": "Änderungen speichern",
  "inventory.uploadImage": "Bild hochladen",
  "inventory.changeImage": "Bild ändern",
  "inventory.removeImage": "Bild entfernen",
  "inventory.imageUploadHint":
    "Maximale Dateigröße: 2 MB. Unterstützte Formate: JPG, PNG.",
  "inventory.imageUploadError": "Fehler beim Hochladen des Bildes.",
  "inventory.imageUploadSuccess": "Bild erfolgreich hochgeladen.",
  "inventory.imageUploadDeleteSuccess":
    "Bild erfolgreich gelöscht.",
  "inventory.imageUploadDeleteError":
    "Fehler beim Löschen des Bildes.",
  "inventory.itemAdded": "Artikel erfolgreich hinzugefügt.",
  "inventory.itemUpdated": "Artikel erfolgreich aktualisiert.",
  "inventory.itemDeleted": "Artikel erfolgreich gelöscht.",
  "inventory.itemNotFound": "Artikel nicht gefunden.",
  "validation.required": "Dieses Feld ist erforderlich.",
  "validation.nonNegativeNumber":
    "Bitte geben Sie eine nicht-negative Zahl ein.",
  inventory: "Inventar",
  "No rows": "Keine Zeilen",
  "Rows per page": "Zeilen pro Seite",
  inventorySummary: "Inventarübersicht",
  noInventoryData: "Keine Inventardaten verfügbar",
  "inventory.searchPlaceholder":
    "Nach Hersteller, Modell, Ty , Menge oder Notizen suchen...",
  image: "Bild",
  Element: "Element",
  quantity: "Menge",
  lastUpdated: "Zuletzt aktualisiert",
  category: "Kategorie",
  Exterior: "Außen",
  Interior: "Innen",
  Engine: "Motor",
  Hydraulics: "Hydraulik",
  Electrical: "Elektrisch",
  Safety: "Sicherheit",
  Cleaning: "Reinigung",
  operationsSection: "Betriebsabschnitt",
  reportStatusSection: "Berichtsstatusabschnitt",
  signedReports: "Unterschriebene Berichte",
  unsignedReports: "Nicht unterschriebene Berichte",
  maintenanceIntervals: "Wartungsintervalle",
  average: "Durchschnitt",
  averageTimeToApproveReport:
    "Durchschnittliche Zeit zur Genehmigung des Berichts",
  serviceTypes: "Servicetypen",
  avgReportsPerMonth: "Durchschnittliche Berichte pro Monat",
  approvalTime: "Genehmigungszeit",
  machines: "Maschinen",
  predictions: "Vorhersagen",
  predictedNextDate: "Vorhergesagtes nächstes Datum",
  operatorPerformance: "Bedienerleistung",
  criticalMachines: "Kritische Maschinen",
  maintenanceByMachine: "Wartung nach Maschine",
  maintenanceByType: "Wartung nach Typ",
  reportTypes: "Berichtstypen",
  total: "Gesamt",
  yearlyComparison: "Jährlicher Vergleich",
  previousYearDataSimulated:
    "Daten des Vorjahres simuliert",
  inventoryDetails: "Inventardetails",
  topCreators: "Top Ersteller",

  // Missing placeholders and fallback strings
  shiftStartPlaceholder: "z.B. Frühschicht, 06:00",
  shiftEndPlaceholder: "z.B. Spätschicht, 14:00",
  weatherPlaceholder: "z.B. Sonnig, leichter Wind",
  temperaturePlaceholder: "z.B. 15",
  fuelLevelPlaceholder: "z.B. 75%",
  fetchingWeatherData: "Wetterdaten werden geladen...",

  // Additional missing translations from form validations and operations
  signatureCannotBeEmpty: "Unterschrift darf nicht leer sein",
  noProfileSignatureAvailable: "Keine Profilunterschrift verfügbar",
  managersOnlyCanCreateBTB: "Nur Manager können Betriebstagebuch-Einträge erstellen",
  pleaseCorrectFormErrors: "Bitte korrigieren Sie die Formularfehler",
  errorFetchingEntry: "Fehler beim Abrufen des Eintrags",
  loadingEntry: "Eintrag wird geladen...",
  accessDenied: "Zugriff verweigert",
  saving: "Speichern...",
  saved: "Gespeichert",
  updateEntry: "Eintrag aktualisieren",
  saveEntry: "Eintrag speichern",
  entryUpdatedSuccess: "Eintrag erfolgreich aktualisiert",
  entryCreatedSuccess: "Eintrag erfolgreich erstellt",
  conveyorNameRequired: "Name des Förderbands ist erforderlich",
  checkNameRequired: "Name der Prüfung ist erforderlich",
  dateIsRequired: "Datum ist erforderlich",
  signatureIsRequired: "Unterschrift ist erforderlich",

  // User Management missing translations
  errorFetchingUsers: "Fehler beim Abrufen der Benutzer",
  nameIsRequired: "Name ist erforderlich",
  emailIsRequired: "E-Mail ist erforderlich",
  invalidEmailFormat: "Ungültiges E-Mail-Format",
  passwordIsRequiredForNewUser: "Passwort ist für neue Benutzer erforderlich",
  userCreatedSuccessfully: "Benutzer erfolgreich erstellt",
  userUpdatedSuccessfully: "Benutzer erfolgreich aktualisiert",
  errorSavingUser: "Fehler beim Speichern des Benutzers",
  userDeletedSuccessfully: "Benutzer erfolgreich gelöscht",
  errorDeletingUser: "Fehler beim Löschen des Benutzers",
  manageUsers: "Benutzer verwalten",
  searchUsers: "Benutzer suchen",
  allRoles: "Alle Rollen",
  noMatchingUsers: "Keine passenden Benutzer gefunden",
  noUsersFound: "Keine Benutzer gefunden",
  createNewUser: "Neuen Benutzer erstellen",
  newPasswordOptional: "Neues Passwort (optional)",
  leaveBlankNoChange: "Leer lassen, um aktuelles Passwort zu behalten",
  confirmUserDeletion: "Benutzer löschen bestätigen",
  areYouSureDeleteUser: "Sind Sie sicher, dass Sie {{name}} löschen möchten?",
  thisActionCannotBeUndone: "Diese Aktion kann nicht rückgängig gemacht werden.",

  // Statistics page missing translations
  errorFetchingStats: "Fehler beim Abrufen der Statistiken",
  noDataToExport: "Keine Daten zum Exportieren",
  csvExportedSuccessfully: "CSV erfolgreich exportiert",
  statisticsAndReports: "Statistiken und Berichte",
  applicationStatistics: "Anwendungsstatistiken",
  printPage: "Seite drucken",
  reportType: "Berichtstyp",
  allExcavators: "Alle Baumaschinen",
  allTypes: "Alle Typen",
  reportStatusDistribution: "Verteilung des Berichtsstatus",
  machineSpecificStatsComingSoon: "Maschinenspezifische Statistiken kommen bald",
  personnelSpecificStatsComingSoon: "Personalspezifische Statistiken kommen bald",
  betriebstagebuchTotal: "Betriebstagebuch Gesamt",

  // Batch generation missing translations
  configurationTemplate: "Konfigurationsvorlage",
  dateRangeForGeneration: "Datumsbereich für Generierung",
  weekendsAreExcludedInfo: "Wochenenden (Samstag und Sonntag) werden automatisch ausgeschlossen",
  dailyEntryTemplate: "Tägliche Eintragsvorlage",
  defaultConveyorChecks: "Standard-Förderband-Prüfungen",
  allConveyorsWillBeAddedInfo: "Alle Förderbänder werden zu jedem Eintrag hinzugefügt",
  signatureRequiredForGeneration: "Unterschrift für Generierung erforderlich",
  noWorkdaysInRange: "Keine Arbeitstage im Bereich",
  adminsOnlyCanAccessBatch: "Nur Administratoren können auf Stapelgenerierung zugreifen",
  // Footer missing translations
  // Additional component translations
  maker: "Hersteller",
  selectFile: "Datei auswählen",
  removeImage: "Bild entfernen",
  approvalTimeframe: "Genehmigungszeitrahmen",
};

export default translations;
